import { Instance } from 'mobx-state-tree';
import { ProjectOptimizeSuccessDtoModelBase } from './ProjectOptimizeSuccessDtoModel.base';

/* The TypeScript type of an instance of ProjectOptimizeSuccessDtoModel */
export interface ProjectOptimizeSuccessDtoModelType extends Instance<typeof ProjectOptimizeSuccessDtoModel.Type> {}

/* A graphql query fragment builders for ProjectOptimizeSuccessDtoModel */
export { selectFromProjectOptimizeSuccessDto, projectOptimizeSuccessDtoModelPrimitives, ProjectOptimizeSuccessDtoModelSelector } from './ProjectOptimizeSuccessDtoModel.base';

/**
 * ProjectOptimizeSuccessDtoModel
 *
 * Optimize success
 */
export const ProjectOptimizeSuccessDtoModel = ProjectOptimizeSuccessDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
